(function(window, document, $) {
  'use strict';

  if (!$) {
    return;
  }

  $(function() {
    var productQty = $('#quick-shop-popup .quantity-product');
    var productImage = $('#qs-product-image');
    var productSku = $('#qs-product-sku');
    var productRating = $('#qs-rating');
    var productTitle = $('#qs-product-title');
    var productDescription = $('#qs-product-description');
    var productVariantWrapper = $('#qs-product-variants');
    var productPrice = $('#qs-product-price');
    var productAddCart = $('#qs-add-cart');
    var productWl = $('#qs-product-wl');
    var productSkuLabel = "SKU";
    var shopName = null;
    var moneyFormat = null;
    var showMultipleCurrencies = true;
    var defaultProductImage = "\/\/auscaterquip.com.au\/cdn\/shop\/t\/2\/assets\/default-image.jpg?v=34021875706906074901779359004";
    var productUrlRoot = "products\/";
    var quickShopQuantityDefault = 1;
    var quickShopDescriptionWordLimit = 25;
    var quickShopFadeDuration = 200;

    function escapeHtml(value) {
      return $('<div>').text(value || '').html();
    }

    function renderProductSku(sku) {
      productSku.empty();

      if (!sku) {
        return;
      }

      $('<span>').text(productSkuLabel + ':').appendTo(productSku);
      productSku.append(document.createTextNode(' ' + sku));
    }

    function refreshCurrencies() {
      if (showMultipleCurrencies && window.currenciesCallbackSpecial) {
        window.currenciesCallbackSpecial('#quick-shop-popup span.money');
      }
    }

    function money(cents) {
      return window.Shopify && window.Shopify.formatMoney ? window.Shopify.formatMoney(cents, moneyFormat) : cents;
    }

    function renderVariantPrice(variant) {
      if (variant.compare_at_price > 0 && variant.compare_at_price > variant.price) {
        productPrice.html(
          '<span class="price-sale">' + money(variant.price) + '</span>' +
          '<del class="price-compare">' + money(variant.compare_at_price) + '</del>'
        );
      } else {
        productPrice.html('<span class="price">' + money(variant.price) + '</span>');
      }
    }

    function selectQSOptionCallback(variant) {
      if (variant && variant.available) {
        if (variant.featured_image) {
          var originalImage = $('#qs-product-image .zoom-qs img');
          var newImage = variant.featured_image;
          var element = originalImage[0];

          window.Shopify.Image.switchImage(newImage, element, function(newImageSizedSrc, image, imageElement) {
            $(imageElement).attr('src', newImageSizedSrc);
            $(imageElement).attr('data-image', newImageSizedSrc);
            $('.zoomWindowContainer div').stop().css('background-image', 'url(' + newImageSizedSrc + ')');
          });
        }

        productAddCart.data('variant-id', variant.id);
        renderProductSku(variant.sku);
        productAddCart.removeAttr('disabled').fadeTo(200, 1);
        renderVariantPrice(variant);
      } else {
        productAddCart.attr('disabled', 'disabled').fadeTo(200, 0.5);
        productPrice.html('<span class="unavailable">Sold Out</span>');
      }

      refreshCurrencies();
    }

    $('#quick-shop-popup').on('shown.bs.modal', function() {
      var zoomImage = $('.zoom-qs .zoom-image');

      if (zoomImage.length && $.fn.elevateZoom) {
        zoomImage.elevateZoom({
          gallery: 'gallery-qs-image',
          galleryActiveClass: 'active',
          zoomType: 'lens',
          cursor: 'pointer',
          lensShape: 'round',
          lensSize: 300
        });
      }

      if ($.fn.owlCarousel) {
        $('#gallery-qs-image').owlCarousel({
          nav: true,
          dots: false,
          mouseDrag: false,
          margin: 25,
          responsive: {
            0: {
              items: 3
            },
            1199: {
              items: 3
            }
          },
          navText: [
            '<i class="fa fa-angle-left" title="Previous"></i>',
            '<i class="fa fa-angle-right" title="Next"></i>'
          ]
        });
      }

      if (window.AT_Main && window.AT_Main.handleReviews) {
        window.AT_Main.handleReviews();
      }
    });

    $('#quick-shop-popup').on('hide.bs.modal', function() {
      $('.zoomContainer').remove();
      if (window.AT_Main && window.AT_Main.refreshZoom) {
        window.AT_Main.refreshZoom();
      }
    });

    $('#quick-shop-popup').on('hidden.bs.modal', function() {
      if (window.AT_Main && window.AT_Main.fixReturnScroll) {
        window.AT_Main.fixReturnScroll();
      }
    });

    $('body').on('click', '.quick_shop:not(.unavailable)', function() {
      var $this = $(this);
      var jsonProduct = $this.find('.json').html();
      var productSelect = JSON.parse(jsonProduct);
      var productSelectID = productSelect.id;
      var productImageAlt = escapeHtml(productSelect.title || shopName);
      var qsImages = productSelect.images;
      var productVariants = productSelect.variants;
      var productVariantsCount = productVariants.length;
      var productVariantElement;
      var productVariantOptions = '';
      var foundOneInStock = false;
      var i;
      var j;

      if (window.AT_Main && window.AT_Main.fixNoScroll) {
        window.AT_Main.fixNoScroll();
      }

      productAddCart.data('product-id', productSelectID);
      productQty.html(window.ThemeQuantity.buildControl({
        inputId: 'qs-quantity',
        inputClass: productSelect.handle + 'item-quantity',
        quantity: quickShopQuantityDefault,
        increaseLabel: 'Increase',
        decreaseLabel: 'Decrease',
        increaseAttrs: {
          'data-src': '#qs-quantity'
        },
        decreaseAttrs: {
          'data-src': '#qs-quantity'
        }
      }));

      productWl.html($(this).closest('.product-wrapper').find('.product-button .product-wishlist').html());
      productImage.empty();

      if (qsImages.length >= 1) {
        productImage.html('<a class="featured-image zoom-qs" title="' + productImageAlt + '"><img class="zoom-image" src="' + window.Shopify.resizeImage(productSelect.featured_image, 'original') + '" data-zoom-image="' + productSelect.featured_image + '" alt="' + productImageAlt + '" /></a>');
      } else {
        productImage.html('<a class="featured-image" title="' + productImageAlt + '"><img src="' + defaultProductImage + '" alt="' + productImageAlt + '" /></a>');
      }

      productImage.append('<div id="gallery-qs-image" class="gallery-thumb-img"></div>');

      $.each(qsImages, function(index, value) {
        var thumbClass = index ? 'thumb-img' : 'thumb-img active';
        productImage.find('#gallery-qs-image').append('<a class="' + thumbClass + '" href="' + value + '" title="' + productImageAlt + ' thumbnail ' + (index + 1) + '" data-image="' + window.Shopify.resizeImage(value, 'original') + '" data-zoom-image="' + window.Shopify.resizeImage(value, 'original') + '"><img src="' + window.Shopify.resizeImage(value, 'small') + '" alt="' + productImageAlt + ' thumbnail ' + (index + 1) + '" /></a>');
      });

      productRating.html('<div class="shopify-product-reviews-badge" data-id="' + productSelectID + '"></div>');
      productTitle.html('<a href="' + productUrlRoot + encodeURIComponent(productSelect.handle) + '">' + escapeHtml(productSelect.title) + '</a>');
      renderProductSku(productVariants.length ? productVariants[0].sku : '');
      productDescription.html(productSelect.description.replace(/(<([^>]+)>)/ig, '').split(' ').splice(0, quickShopDescriptionWordLimit).join(' ') + '...');
      productPrice.empty();
      productVariantWrapper.empty();
      productAddCart.removeAttr('disabled').fadeTo(quickShopFadeDuration, 1);

      productVariantElement = $('<select>', {
        id: '#quick-shop-variants-' + productSelectID,
        name: 'id'
      });

      for (i = 0; i < productVariantsCount; i += 1) {
        productVariantOptions += '<option value="' + productVariants[i].id + '">' + productVariants[i].title + '</option>';
      }

      productVariantElement.append(productVariantOptions);
      productVariantWrapper.append(productVariantElement);

      if (productVariantsCount > 1) {
        productVariantWrapper.show();
        new window.Shopify.OptionSelectors('#quick-shop-variants-' + productSelectID, {
          product: productSelect,
          onVariantSelected: selectQSOptionCallback
        });

        if (productSelect.options.length === 1) {
          $('#qs-product-action .selector-wrapper:eq(0)').prepend('<label>' + productSelect.options[0] + '</label>');
        }

        for (i = 0; i < productVariants.length; i += 1) {
          if (productVariants[i].available && foundOneInStock === false) {
            foundOneInStock = true;

            for (j = 0; j < productVariants[i].options.length; j += 1) {
              $('.single-option-selector:eq(' + j + ')').val(productVariants[i].options[j]).trigger('change');
            }
          }
        }
      } else {
        productVariantWrapper.hide();
        productAddCart.data('variant-id', productVariants[0].id);
        renderVariantPrice(productVariants[0]);
      }

      refreshCurrencies();
    });
  });
}(window, document, window.jQuery));
